import resfult from "@/services/resful.js";
export const service = {
  uploadSheet: async function(data, next) {
    let res = await resfult.uploadSheet("/app/sheet", data);
    next(res);
  },
};
